import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const TermSheetPromoterUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  name,
  guarantor, onGuarantorChange, guarantorError,
  sharePledgedPercent, onSharePledgedPercentChange, sharePledgedPercentError, setSharePledgedPercentError,
  booleanList,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update promoter'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <b>{name}</b>
    <InputSelectUI name='guarantor' value={guarantor}
      label='Guarantor' optionList={booleanList}
      onChange={onGuarantorChange} error={guarantorError}
    />
    <InputTextSF type='text' name='sharePledgedPercent' label='Percentage of shares pledged'
      maxLength={8}
      value={sharePledgedPercent} onChange={onSharePledgedPercentChange}
      error={sharePledgedPercentError} setError={setSharePledgedPercentError}
    />
  </ModalFormUI>

export default TermSheetPromoterUpdateModalUI
